import React from "react";
import PropTypes from "prop-types";
import Link from "./link.js";
import { reisy, use } from "reisy";
import DropdownItem from "../navigation/dropdown.js";
import { Button } from "../navigation/items.js";
import Heading from "./heading";

export const styles = {};

/* TODO create extend for common menu styles */

const common = reisy`
@namespace MenuCommon;

padding: .5em;

list {
	display: flex;
	flex-direction: row;
	padding: 0;
	margin: 0;

	$Media.smaller {
		flex-direction: column;
	}

	$Navigation.Expanded & {
		flex-direction: column;
	}
}

separator {
	$Media.small {
		&::before {
			content: "|";
		}
		&:first-child::before {
			display: none;
		}
	}

	$Navigation.Expanded & {
		&::before {
			content: "";
		}
	}
}

listItem {
	@extends separator;
	list-style: none;
	margin: 0;
}

itemActive {

}

listLink {
	padding: 0;
	text-decoration: none;
	color: $Colors.TextLight;
	&:hover {
		text-decoration: underline;
	}

	$Navigation.Expanded & {
		display: block;
		width: 100%;
		padding: .75em 0;
		text-transform: uppercase;
	}

	$Media.small {
		padding: 0 $MenuCommon.padding;
	}

	$(separator):last-child $(listItem):last-child & {
		$Media.small {
			padding-right: 0;
		}
	}

	$(separator):first-child $(listItem):first-child & {
		$Media.small {
			padding-left: 0;
		}
	}
}

linkActive {
	text-decoration: underline;
}

imageLink {
	display: flex;
	align-items: center;
}

label {

}
`;

styles.links = reisy`
@namespace MenuLinks;

menu {

}

wrapperCommon {
	$menu $listItem:first-child $listLink {
		padding-left: 0;
	}

	$menu $listItem:last-child $listLink {
		padding-right: 0;
	}
}

wrapper {
	@extends wrapperCommon;

	margin-top: 4rem;

	$Media.short {
		margin-top: 1em;
	}
}
title {
	font-family: $Fonts.title;
	font-weight: normal;
	margin-bottom: .5em;
	color: $Colors.TextLight;
}
list {
	@extends MenuCommon.list;

	justify-content: center;
	font-family: $Fonts.aside;
	font-size: .85em;
}

listItem {
	@extends MenuCommon.listItem;
}
itemActive {
	@extends MenuCommon.itemActive;
}
listLink {
	@extends MenuCommon.listLink;
}
linkActive {
	@extends MenuCommon.linkActive;
}

imageLink {
	@extends MenuCommon.imageLink;
}
`;

styles.top = reisy`
@namespace MenuTop;

wrapper {
	@extends MenuLinks.wrapperCommon;
	display: flex;

	$Navigation.Expanded & {
		flex-direction: column;
	}
}

menu {
	display: flex;
	align-items: center;
	@extends MenuCommon.separator;
}
list {
	@extends MenuCommon.list;
	$Media.smaller {
		text-align: left;
	}
}
listItem {
	@extends MenuCommon.listItem;
}
itemActive {
	@extends MenuCommon.itemActive;
}
listLink {
	@extends MenuCommon.listLink;
}
linkActive {
	@extends MenuCommon.linkActive;
}

imageLink {
	@extends MenuCommon.imageLink;
}
`;

styles.main = reisy`
@namespace MenuMain;

menu {
	padding: 1rem;
}

list {
	@extends MenuCommon.list;
	display: flex;
	justify-content: center;
	align-items: center;
}
listItem {
	@extends MenuCommon.listItem;
}
itemActive {
	@extends MenuCommon.itemActive;
}
listLink {
	@extends MenuCommon.listLink;
}
linkActive {
	@extends MenuCommon.linkActive;
}

imageLink {
	@extends MenuCommon.imageLink;
}
wrapper {

}
`;

styles.footer = reisy`
@namespace MenuFooter;

wrapper {

}

menu {

}

title {

}

list {
	@extends MenuCommon.list;
	justify-content: center;
	margin-top: .25em;
}

listItem {
	@extends MenuCommon.listItem;
	font-family: $Fonts.aside;
	color: $Footer.ForegroundSecondaryColor;
}
itemActive {
	@extends MenuCommon.itemActive;
}

listLink {
	@extends MenuCommon.listLink;
	color: inherit;
}
linkActive {
	@extends MenuCommon.linkActive;
}

imageLink {
	@extends MenuCommon.imageLink;
}
`;

styles.psFooter = reisy`
@namespace MenuPSFooter;

list {
	@extends Footer.sectionList, Footer.sectionPagestripList;
}

listItem {
	@extends Footer.sectionListItem;
}
itemActive {

}

`;

const dropdown = reisy`
@namespace MenuDropdown;

Button {
	font-size: 16px;
	margin: 0;

	$Media.ltMedium {
		margin: 0;
		padding: 0;
		pointer-events: none;
	}
}

menu {
	$Navigation.Dropdown {
		$Media.ltMedium {
			position: static;
			margin: 0;
			padding: 0;
			box-shadow: none;
			display: block !important;

			&::before {
				display: none;
			}
		}
	}
}

list {
	padding-left: 2rem;
	padding-right: 2rem;
	list-style: none;

	$Media.ltMedium {
		padding-left: 1rem;
		padding-right: 1rem;
	}
}

listLink {
	color: inherit;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
}
linkActive {
	@extends MenuCommon.linkActive;
}

`;

export const ListItem = ({ styles, item, active, onClick, selectedTags }) => (
	<li
		{...use(
			item.itemType === "separator"
				? styles.listItemSeparator
				: styles.listItem,
			active ? styles.itemActive : null
		)}
	>
		{item.itemType === "separator" ? (
			<span {...use(styles.label)}>{item.label}</span>
		) : !item.useNewTab &&
		  (item.itemType === "article" ||
				item.itemType === "collection" ||
				item.itemType === "anchor" ||
				item.itemType === "tagfilter" ||
				item.itemType === "tag" ||
				item.url.startsWith("#") ||
				item.url.startsWith("?")) ? (
			<Link
				{...use([
					styles.listLink,
					active ? styles.linkActive : null,
					item.image ? styles.imageLink : null,
				])}
				to={
					item.to && selectedTags
						? { ...item.to, query: { ...item.to.query, tags: selectedTags } }
						: item.to || item.url
				}
				onClick={onClick}
			>
				{item.image ? (
					<img src={item.image} />
				) : (
					<span {...use(styles.label)}>{item.label}</span>
				)}
			</Link>
		) : (
			<a
				{...use([styles.listLink, item.image ? styles.imageLink : null])}
				href={item.url}
				target={item.useNewTab ? "_blank" : "_self"}
				rel="noreferrer noopener"
			>
				{item.image ? (
					<img src={item.image} />
				) : (
					<span {...use(styles.label)}>{item.label}</span>
				)}
			</a>
		)}
	</li>
);

const List = ({ styles, items, active, onItemClick, selectedTags }) => (
	<ul {...use(styles.list)}>
		{items.map((item, i) => (
			<ListItem
				key={i}
				styles={styles}
				item={item}
				active={
					active &&
					(
						item.to &&
						item.to.hierarchy &&
						(item.to.hierarchy.slice(-1)[0] || {}).id === active
						||
						IS_BROWSER && item.url === window.location.toString()
					)
				}
				onClick={onItemClick}
				selectedTags={selectedTags}
			/>
		))}
	</ul>
);

const Menu = ({
	position,
	menues,
	active,
	menuid,
	onItemClick,
	selectedTags,
}) => {
	if (!menues) {
		return null;
	}
	const items = menues[position];
	if (typeof items === "undefined") {
		return null;
	}
	const style = styles[position] || common;

	return (
		<div {...use(style.wrapper)}>
			{items.map(
				(menu, i) =>
					(!menuid || menu.id === menuid) &&
					(menu.options && menu.options.style === "dropdown" ? (
						<DropdownItem
							{...use(dropdown.menu)}
							renderHidden={true}
							openOnHover={true}
							item="menu"
							button={<Button style={dropdown.Button}>{menu.title}</Button>}
							key={i}
						>
							<List
								styles={dropdown}
								items={menu.items}
								active={active}
								onItemClick={onItemClick}
							/>
						</DropdownItem>
					) : (
						<div
							{...use(style.menu, menu.options && menu.options.className)}
							key={i}
						>
							{menu.title ? (
								<Heading lvl={3} {...use(style.title)}>
									{menu.title}
								</Heading>
							) : null}
							<List
								styles={style}
								items={menu.items}
								active={active}
								onItemClick={onItemClick}
								selectedTags={
									menu.options && menu.options.keepTags ? selectedTags : null
								}
							/>
						</div>
					))
			)}
		</div>
	);
};

export default Menu;

Menu.propTypes = {
	position: PropTypes.oneOf(["top", "links", "main", "footer", "psFooter"]),
	menues: PropTypes.object,
};



// WEBPACK FOOTER //
// ./lib/components/menu.js